<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <modal :open="open" @close="close()">
    <template v-slot:modelcontent>
      <div>
        <div class="mt-3 text-center sm:mt-5">
          <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> Compile Asbestos Register</DialogTitle>
          <div class="mt-5">
              Please ask UKNAR to email <a href="mailto:enquiries@uknar.org">enquiries@uknar.org</a> to compile asbestos register
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
      </div>
    </template>
  </modal>
</template>

<script>
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {CheckIcon} from '@heroicons/vue/outline'

export default {
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckIcon,
    },

    props: {
      open: false
    },

    methods: {
        close: function (type = '') {
          this.$emit('closed', type);
        },
    }
}
</script>
